//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/components/popup-header/index.vue